import {Component} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {HttpClient} from '@angular/common/http';
import {CommonModule} from '@angular/common';
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {FaIconLibrary, FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {
    faEye,
    faEyeSlash,
    faSquareCheck,
    faSquarePlus,
    faSquareXmark,
    faUnlockKeyhole
} from '@fortawesome/free-solid-svg-icons';
import {ToastrService} from 'ngx-toastr';
import {ApiService} from '../../services/api.service';
import {AuthService} from '../../services/auth.service';
import {validateAllFormFields} from '../../../common/utils';
// import { SpinnerComponent } from '../../spinner/spinner.component';
// import { LoadingService } from '../../services/loading.service';

@Component({
    selector: 'app-signup',
    imports: [CommonModule, ReactiveFormsModule, FontAwesomeModule, FormsModule],
    templateUrl: './signup.component.html',
    styleUrl: './signup.component.css'
})
export class SignupComponent {
  isPasswordVisible: Boolean = false;
    isDemoStaff = false;
    demoExpiryDays = 7;
    demoExpiryOptions = [3, 7, 10, 15, 30];
    isPlatformSuperuser = false;
  signupForm: FormGroup;
  group: object  = {};
  organization: any = {};
    assignedOrganizationName = '';



  constructor(private http: HttpClient,
              private router: Router,
              private route: ActivatedRoute,
              library: FaIconLibrary,
              private toastr: ToastrService,
              fb: FormBuilder,
              private apiService: ApiService,
              private authService: AuthService,
              // public loadingservice: LoadingService
  ) {
    library.addIcons(faUnlockKeyhole,
                    faSquareCheck,
                    faEyeSlash,
                    faEye,
                    faSquarePlus,
                    faSquareXmark
                  );

      this.groups();
      this.organizations();
      this.isPlatformSuperuser = this.authService.isSuperUser();
      this.isDemoStaff = this.route.snapshot.queryParamMap.get('demo') === 'true' && this.isPlatformSuperuser;
      this.route.queryParamMap.subscribe((params) => {
          const demoMode = params.get('demo') === 'true' && this.isPlatformSuperuser;
          if (demoMode !== this.isDemoStaff) {
              this.isDemoStaff = demoMode;
              this.groups();
          }
      });

    this.signupForm = fb.group({
      userName: ['', Validators.required],
      firstName: ['', Validators.required],
      lastName: [''],
      email: ['', Validators.required],
      mobileNumber: ['', [Validators.required,
                          Validators.minLength(10),
                          Validators.maxLength(14),
      ]],
      groups: [[], Validators.required],
      organization: ['', Validators.required],
      // password: ['',[Validators.required,
      //                 Validators.minLength(8),
      //           ]],
      // confirmPassword: ['', [Validators.required,
      //                       Validators.minLength(8),
      //               ]],
     
    });

  }
  // ngOnInit(): void {
   
  // }

  groups(){
    this.apiService.getGroups().subscribe({
      next: (response: any) => {
          if (this.isDemoStaff) {
              this.group = Object.fromEntries(
                  Object.entries(response).filter(([, name]) => name === 'Demo User')
              );
              const demoRole = Object.values(this.group)[0];
              if (demoRole) {
                  this.signupForm.patchValue({groups: demoRole});
              }
          } else {
              this.group = Object.fromEntries(
                  Object.entries(response).filter(([, name]) => name !== 'Demo User')
              );
          }
      },
      error: (err) =>{
        this.toastr.error('Error while getting role.', 'Error');
      }
    })
  }

  organizations(){
    this.apiService.organization().subscribe({
      next: (response: any) => {
        this.organization = response
        if (this.organization){
            const orgDefault = Object.values(this.organization)[0] as string;
            this.assignedOrganizationName = orgDefault;
          this.signupForm.patchValue({'organization': orgDefault})
        }
      },
      error: (err) =>{
        this.toastr.error('Error while getting organization.', 'Error');
      }
    })
  }

  

  onSubmit() {
    if (this.signupForm.valid){
      // this.loadingservice.setLoading('signup', true)
      // let formData = new FormData();
      // formData.append('username', this.signupForm.value.userName)
      // formData.append('first_name', this.signupForm.value.firstName)
      // formData.append('last_name', this.signupForm.value.lastName)
      // formData.append('email', this.signupForm.value.email.toLowerCase())
      // formData.append('mobile_number', this.signupForm.value.mobileNumber)
      // formData.append('password', "Secure@123")
      // formData.append('confirm_password', "Secure@123")

      // // let group =  getKeyByValue(this.group, this.signupForm.value.groups) ?? '';
      // // console.log('role',group);
      // // let organization =  getKeyByValue(this.organization, this.signupForm.value.organization) ?? '';
      // // console.log('organization',organization);

      // // formData.append('groups', this.signupForm.value.groups)
      // // Convert groups to array if it's not already
      // // const groupsArray = Array.isArray(this.signupForm.value.groups) 
      // // ? this.signupForm.value.groups 
      // // : [this.signupForm.value.groups];

      // // // Convert selected groups to array of IDs
      // // const groupsArray = Array.isArray(this.signupForm.value.groups) 
      // //   ? this.signupForm.value.groups 
      // //   : [this.signupForm.value.groups];

      // // // Append each group ID separately to FormData
      // // groupsArray.forEach((groupId: any) => {
      // //   formData.append('groups[]', groupId);
      // // });

      // // formData.append('organization', '3')
      // // Convert selected groups to array
      // const groupsArray = Array.isArray(this.signupForm.value.groups) 
      //   ? this.signupForm.value.groups 
      //   : [this.signupForm.value.groups];

      // // Try one of these approaches:
      
      // // Approach 1: Send as multiple values with the same key
      // groupsArray.forEach((groupId: any) => {
      //   formData.append('groups', groupId);  // Remove the [] from the key name
      // });

      // // OR Approach 2: Send as a comma-separated string
      // // formData.append('groups', groupsArray.join(','));
      
      // formData.append('organization', '3')

      //  // Alternative debug approach
      //  const formDataObj: any = {};
      //  formData.forEach((value, key) => {
      //      formDataObj[key] = value;
      //  });
      //  console.log('Form data object:', formDataObj);


      // Random Password
      const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()_+';
      let password = '';
      for (let i = 0; i < 12; i++) {
        password += chars.charAt(Math.floor(Math.random() * chars.length));
      }
      const formValues = this.signupForm.value;
        const organizationName = this.isPlatformSuperuser
            ? formValues.organization
            : (this.assignedOrganizationName || formValues.organization);
        // Create the request body as a plain object first
        const requestData: any = {
        username: formValues.userName,
        first_name: formValues.firstName,
        last_name: formValues.lastName,
        email: formValues.email.toLowerCase(),
        mobile_number: formValues.mobileNumber,
        password: password,
        confirm_password: password,
        groups: Array.isArray(formValues.groups) ? formValues.groups : [formValues.groups],
          organization: organizationName
      };

        if (this.isDemoStaff) {
            requestData.is_demo_user = true;
            requestData.demo_expiry_days = this.demoExpiryDays;
        }


      this.apiService.signUp(requestData).subscribe({
        next: (response) => {
          // this.loadingservice.setLoading('signup', false)
            this.toastr.success(
                this.isDemoStaff ? 'Demo staff account created successfully.' : 'New Staff added successfully.',
                'Success'
            );
          this.router.navigate(['/organization'], {state: {"activeTab": "staff"}});
        },
        error: (err) => {
          // this.loadingservice.setLoading('signup', false)

          if (err['error']['non_field_errors']) {
            err['error']['non_field_errors'].forEach((element:any) => {
              this.toastr.error(element, 'Error');
            });
          }else if (err['error']['mobile_number']) {
            err['error']['mobile_number'].forEach((element:any) => {
              this.toastr.error(element, 'Error');
            });
          }else if (err['error']['organization']) {
            err['error']['organization'].forEach((element:any) => {
              this.toastr.error(element, 'Error');
            });
          }else if (err['error']['email']) {
            err['error']['email'].forEach((element:any) => {
              this.toastr.error(element, 'Error');
            });
          }else if (err['error']['username']) {
            err['error']['username'].forEach((element:any) => {
              this.toastr.error(element, 'Error');
            });
          }else if (err['error']['first_name']) {
            err['error']['first_name'].forEach((element:any) => {
              this.toastr.error(element, 'Error');
            });
          }else if (err['error']['last_name']) {
            err['error']['last_name'].forEach((element:any) => {
              this.toastr.error(element, 'Error');
            });
          }else if (err['error']['groups']) {
            err['error']['groups'].forEach((element:any) => {
              this.toastr.error(element, 'Error');
            });
          }else if (err['error']['organization']) {
            err['error']['organization'].forEach((element:any) => {
              this.toastr.error(element, 'Error');
            });
          }
          else if (err['status'] !== 403 && err.status !== 0) {
            this.toastr.error(err.error.detail, 'Error');
          }
        }
      });
    }else{
      validateAllFormFields(this.signupForm);
    }
  }

  togglePasswordVisibility(){
    this.isPasswordVisible = !this.isPasswordVisible;
  }

  onCancel() {
    this.router.navigate(['organization'], {state: {'activeTab': 'staff'}})

  }
}
